// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__7L8iV","label":"Radio_label__3WhVz","checkMark":"Radio_checkMark__1xzuo","disabled":"Radio_disabled__2bpKt"};